/* ============================================================
   Salty Seats - sold-out cards open STOQ's signup modal.

   STOQ only auto-places its Notify me button on markup it
   recognises, and our cards are our own, so it is called directly
   through its documented API instead:

     window._RestockRocket.openModal(productData, variantId)

   The listener is delegated from the document rather than bound per
   button, because the collection grid appends more cards as you load
   them and a bound listener would miss every one of those.
   ============================================================ */

(function () {
  'use strict';

  var WAIT_MS = 150;
  var WAIT_TRIES = 12; /* ~1.8s, then give up and use the link */

  function api() {
    var rr = window._RestockRocket;
    return rr && typeof rr.openModal === 'function' ? rr : null;
  }

  function open(btn) {
    var rr = api();
    if (!rr) return false;

    var raw = btn.getAttribute('data-ss-notify-product');
    var variant = btn.getAttribute('data-ss-notify-variant');
    if (!raw || !variant) return false;

    var product;
    try {
      product = JSON.parse(raw);
    } catch (e) {
      return false;
    }

    try {
      /* variantId is documented as a string. */
      rr.openModal(product, String(variant));
    } catch (e) {
      return false;
    }
    return true;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    var btn = t.closest('[data-ss-notify]');
    if (!btn) return;

    if (open(btn)) {
      e.preventDefault();
      return;
    }

    /* Already waiting on the app from an earlier click - let this one
       through so a second press is never a dead press. */
    if (btn.getAttribute('data-ss-notify-waiting') === '1') return;

    /* The app embed loads asynchronously, so an early click can land
       before it is there. Hold the click briefly, then fall back to
       the product page, where STOQ places its own widget. */
    e.preventDefault();
    btn.setAttribute('data-ss-notify-waiting', '1');

    var tries = 0;
    var timer = window.setInterval(function () {
      tries++;
      if (open(btn)) {
        window.clearInterval(timer);
        btn.removeAttribute('data-ss-notify-waiting');
        return;
      }
      if (tries >= WAIT_TRIES) {
        window.clearInterval(timer);
        btn.removeAttribute('data-ss-notify-waiting');
        /* Cards fall back to the product page. The PDP buttons have no
           href - they are already on it - so there is nowhere to go. */
        var href = btn.getAttribute('href');
        if (href) window.location.href = href;
      }
    }, WAIT_MS);
  });
})();
